var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,33.617a2.4,2.4,0,1,0,2.4,2.4,2.4,2.4,0,0,0-2.4-2.4m0-24a2.4,2.4,0,0,0-2.4,2.4v16.8a2.4,2.4,0,1,0,4.8,0v-16.8a2.4,2.4,0,0,0-2.4-2.4M7.2,43.2a2.4,2.4,0,0,1-2.4-2.4V7.2A2.4,2.4,0,0,1,7.2,4.8H40.8a2.4,2.4,0,0,1,2.4,2.4V40.8a2.4,2.4,0,0,1-2.4,2.4H7.2M43.2,0H4.8A4.807,4.807,0,0,0,0,4.808v38.41A4.785,4.785,0,0,0,4.8,48H43.2A4.792,4.792,0,0,0,48,43.208V4.817A4.983,4.983,0,0,0,43.2,0",
    transform: "translate(0 -0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b091f930d7e3743bea364bca5294681f.svg";
export { ForwardRef as ReactComponent };